// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CMDB Main Styles — theme-aware */

:root {
  --primary-color: var(--accent);
  --secondary-color: var(--text-secondary);
  --success-color: #10b981;
  --danger-color:  #ef4444;
  --warning-color: #f59e0b;
  --info-color:    #06b6d4;
  --light:         var(--bg-card);
  --dark:          var(--text-primary);
  --border-color:  var(--border);
  --shadow:        var(--shadow-sm);

  /* Override Bootstrap 5 root variables */
  --bs-body-bg: var(--slate-50);
  --bs-body-color: var(--text-primary);
  --bs-card-bg: var(--bg-card);
  --bs-card-border-color: var(--border);
  --bs-card-color: var(--text-primary);
  --bs-border-color: var(--border);
  --bs-tertiary-bg: var(--bg-toolbar);
  --shadow-lg:     var(--shadow-lg);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--slate-50);
  color: var(--text-primary);
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Navigation */
.navbar {
  box-shadow: var(--shadow-sm);
  background: var(--bg-card) !important;
  border-bottom: 1px solid var(--border);
}

.nav-link {
  color: var(--text-secondary) !important;
  transition: color 0.3s ease;
}

.nav-link:hover {
  color: var(--accent-l) !important;
}

/* Main Container */
.container-fluid {
  padding: 1rem;
}

/* Cards */
.card {
  background: var(--bg-card) !important;
  border: 1px solid var(--border) !important;
  box-shadow: var(--shadow-sm);
  border-radius: 12px;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  color: var(--text-primary);
}

.card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
  border-color: var(--slate-300);
}

.card-header {
  background: var(--bg-toolbar);
  border-bottom: 1px solid var(--border);
  color: var(--text-primary);
}

.card-body { color: var(--text-primary); }

/* Tables */
.table {
  background-color: transparent;
  border-collapse: collapse;
  color: var(--text-primary);
}

.table thead {
  background-color: var(--bg-toolbar);
  font-weight: 600;
}

.table tbody tr {
  border-bottom: 1px solid var(--border);
}

.table tbody tr:hover {
  background-color: var(--bg-toolbar);
}

/* Forms */
.form-control,
.form-select {
  background: var(--bg-input);
  border: 1px solid var(--border);
  color: var(--text-primary) !important;
  border-radius: 8px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.form-control:focus,
.form-select:focus {
  background: var(--bg-input);
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(var(--accent-rgb),.2);
  color: var(--text-primary) !important;
}

.form-control::placeholder { color: var(--text-muted); }

.form-control:-webkit-autofill,
.form-control:-webkit-autofill:focus {
  -webkit-text-fill-color: var(--text-primary) !important;
  -webkit-box-shadow: 0 0 0 1000px var(--bg-input) inset !important;
}

.form-label { color: var(--text-secondary); font-weight: 500; }

/* ── Global native element overrides ─────────────────────── */
/* Catches any input/select/textarea not covered by component CSS.
 *
 * \`.sf2-head-input\` queda fuera a propósito: es el título editable de las
 * fichas en tarjetas (patrón inline edit) y necesita verse como un h1 sin caja
 * en reposo. Sin esta exclusión, el \`!important\` de aquí le pone fondo y borde
 * de campo siempre y no hay forma de pintarlo como título sin recurrir a otro
 * \`!important\` de mayor especificidad. */
input:not([type='checkbox']):not([type='radio']):not([type='range']):not([type='submit']):not([type='button']):not([type='reset']):not(.sf2-head-input),
select,
textarea {
  background-color: var(--bg-input) !important;
  border: 1px solid var(--border) !important;
  color: var(--text-primary) !important;
  border-radius: 6px;
  font-family: inherit;
}

input:not([type='checkbox']):not([type='radio']):not([type='range']):not([type='submit']):not([type='button']):not([type='reset']):not(.sf2-head-input)::placeholder,
textarea::placeholder {
  color: var(--text-muted) !important;
}

input:not([type='checkbox']):not([type='radio']):not([type='range']):not([type='submit']):not([type='button']):not([type='reset']):not(.sf2-head-input):focus,
select:focus,
textarea:focus {
  outline: none !important;
  border-color: var(--accent) !important;
  box-shadow: 0 0 0 3px rgba(var(--accent-rgb),.2) !important;
}

select option {
  background: var(--bg-surface);
  color: var(--text-primary);
}


/* Buttons */
.btn {
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.15s ease;
}

.btn:hover {
  transform: translateY(-1px);
}

.btn-primary {
  background: linear-gradient(135deg, var(--accent), var(--accent-2));
  border: none;
  color: #fff;
}

.btn-primary:hover {
  background: linear-gradient(135deg, var(--accent-dark), #6d28d9);
  box-shadow: 0 6px 20px rgba(var(--accent-rgb),.4);
}

/* Modals */
.modal-content {
  background: var(--bg-surface);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-lg);
  border-radius: 16px;
  color: var(--text-primary);
}

.modal-header {
  background: var(--bg-toolbar);
  border-bottom: 1px solid var(--border);
}

.modal-footer {
  background: var(--bg-toolbar);
  border-top: 1px solid var(--border);
}

/* Badges */
.badge {
  border-radius: 0.25rem;
  font-weight: 500;
}

/* Alerts */
.alert {
  border-radius: 0.375rem;
  border: none;
}

.alert-success {
  background-color: rgba(25, 135, 84, 0.1);
  color: #155724;
}

.alert-danger {
  background-color: rgba(220, 53, 69, 0.1);
  color: #721c24;
}

.alert-warning {
  background-color: rgba(255, 193, 7, 0.1);
  color: #856404;
}

.alert-info {
  background-color: rgba(13, 202, 240, 0.1);
  color: #0c5460;
}

/* Loading Spinner */
.spinner-border {
  color: var(--primary-color);
}

/* Pagination */
.pagination .page-link {
  color: var(--primary-color);
  border: 1px solid var(--border-color);
}

.pagination .page-link:hover {
  background-color: var(--light);
  border-color: var(--border-color);
}

.pagination .page-item.active .page-link {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
}

/* Utility Classes */
.text-muted {
  color: var(--secondary-color) !important;
}

.bg-light {
  background-color: var(--light) !important;
}

.border-top {
  border-top: 1px solid var(--border-color) !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

/* Responsive */
@media (max-width: 768px) {
  .container-fluid {
    padding: 0.5rem;
  }

  .card {
    margin-bottom: 1rem;
  }

  .table {
    font-size: 0.875rem;
  }
}

/* Rack Visualization */
.rack-container {
  background-color: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  padding: 1rem;
  margin: 1rem 0;
  box-shadow: var(--shadow);
}

.rack-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  padding: 1rem;
}

.rack-item {
  background-color: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 0.375rem;
  padding: 0.75rem;
  text-align: center;
  transition: all 0.3s ease;
}

.rack-item:hover {
  border-color: var(--primary-color);
  box-shadow: var(--shadow-lg);
  transform: scale(1.02);
}

/* Footer
   -------------------------------------------------------------------------
   Aquí había un \`footer { background-color: var(--dark); color: white;
   padding: 2rem 1rem; ... }\` heredado de una landing. En una aplicación no
   tiene sentido: \`--dark\` es el color de TEXTO principal, así que cualquier
   componente que usara <footer> como barra de acciones se pintaba con una caja
   clara en modo oscuro y centrada. Ahora mismo el panel de plataforma usa
   <footer className="pa-detail-actions"> y se estilaba mal. Si algún día hace
   falta un pie de página de verdad, que sea una clase propia (\`.app-footer\`),
   nunca la etiqueta global. */
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,+BAA+B;EAC/B,oCAAoC;EACpC,8BAA8B;EAC9B,iCAAiC;;EAEjC,wCAAwC;EACxC,6BAA6B;EAC7B,oCAAoC;EACpC,4BAA4B;EAC5B,qCAAqC;EACrC,oCAAoC;EACpC,gCAAgC;EAChC,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,+EAA+E;EAC/E,mCAAmC;EACnC,kCAAkC;EAClC,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE;aACW;AACb;;AAEA,eAAe;AACf;EACE,4BAA4B;EAC5B,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA,mBAAmB;AACnB;EACE,aAAa;AACf;;AAEA,UAAU;AACV;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,4BAA4B;EAC5B,mBAAmB;EACnB,6EAA6E;EAC7E,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA,aAAa,0BAA0B,EAAE;;AAEzC,WAAW;AACX;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,UAAU;AACV;;EAEE,2BAA2B;EAC3B,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,0DAA0D;AAC5D;;AAEA;;EAEE,2BAA2B;EAC3B,2BAA2B;EAC3B,gDAAgD;EAChD,qCAAqC;AACvC;;AAEA,6BAA6B,wBAAwB,EAAE;;AAEvD;;EAEE,uDAAuD;EACvD,iEAAiE;AACnE;;AAEA,cAAc,4BAA4B,EAAE,gBAAgB,EAAE;;AAE9D,+DAA+D;AAC/D;;;;;;yCAMyC;AACzC;;;EAGE,4CAA4C;EAC5C,0CAA0C;EAC1C,qCAAqC;EACrC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;;;EAGE,wBAAwB;EACxB,sCAAsC;EACtC,2DAA2D;AAC7D;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;;AAGA,YAAY;AACZ;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mEAAmE;EACnE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gEAAgE;EAChE,iDAAiD;AACnD;;AAEA,WAAW;AACX;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,4BAA4B;EAC5B,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA,WAAW;AACX;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA,oBAAoB;AACpB;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,uBAAuB;AACvB;EACE,gCAAgC;EAChC,qCAAqC;EACrC,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;;;;;;;;;8BAS8B","sourcesContent":["/* CMDB Main Styles — theme-aware */\r\n\r\n:root {\r\n  --primary-color: var(--accent);\r\n  --secondary-color: var(--text-secondary);\r\n  --success-color: #10b981;\r\n  --danger-color:  #ef4444;\r\n  --warning-color: #f59e0b;\r\n  --info-color:    #06b6d4;\r\n  --light:         var(--bg-card);\r\n  --dark:          var(--text-primary);\r\n  --border-color:  var(--border);\r\n  --shadow:        var(--shadow-sm);\r\n\r\n  /* Override Bootstrap 5 root variables */\r\n  --bs-body-bg: var(--slate-50);\r\n  --bs-body-color: var(--text-primary);\r\n  --bs-card-bg: var(--bg-card);\r\n  --bs-card-border-color: var(--border);\r\n  --bs-card-color: var(--text-primary);\r\n  --bs-border-color: var(--border);\r\n  --bs-tertiary-bg: var(--bg-toolbar);\r\n  --shadow-lg:     var(--shadow-lg);\r\n}\r\n\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  background-color: var(--slate-50);\r\n  color: var(--text-primary);\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\r\n    monospace;\r\n}\r\n\r\n/* Navigation */\r\n.navbar {\r\n  box-shadow: var(--shadow-sm);\r\n  background: var(--bg-card) !important;\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n\r\n.nav-link {\r\n  color: var(--text-secondary) !important;\r\n  transition: color 0.3s ease;\r\n}\r\n\r\n.nav-link:hover {\r\n  color: var(--accent-l) !important;\r\n}\r\n\r\n/* Main Container */\r\n.container-fluid {\r\n  padding: 1rem;\r\n}\r\n\r\n/* Cards */\r\n.card {\r\n  background: var(--bg-card) !important;\r\n  border: 1px solid var(--border) !important;\r\n  box-shadow: var(--shadow-sm);\r\n  border-radius: 12px;\r\n  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.card:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: var(--shadow-md);\r\n  border-color: var(--slate-300);\r\n}\r\n\r\n.card-header {\r\n  background: var(--bg-toolbar);\r\n  border-bottom: 1px solid var(--border);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.card-body { color: var(--text-primary); }\r\n\r\n/* Tables */\r\n.table {\r\n  background-color: transparent;\r\n  border-collapse: collapse;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.table thead {\r\n  background-color: var(--bg-toolbar);\r\n  font-weight: 600;\r\n}\r\n\r\n.table tbody tr {\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n\r\n.table tbody tr:hover {\r\n  background-color: var(--bg-toolbar);\r\n}\r\n\r\n/* Forms */\r\n.form-control,\r\n.form-select {\r\n  background: var(--bg-input);\r\n  border: 1px solid var(--border);\r\n  color: var(--text-primary) !important;\r\n  border-radius: 8px;\r\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\r\n}\r\n\r\n.form-control:focus,\r\n.form-select:focus {\r\n  background: var(--bg-input);\r\n  border-color: var(--accent);\r\n  box-shadow: 0 0 0 3px rgba(var(--accent-rgb),.2);\r\n  color: var(--text-primary) !important;\r\n}\r\n\r\n.form-control::placeholder { color: var(--text-muted); }\r\n\r\n.form-control:-webkit-autofill,\r\n.form-control:-webkit-autofill:focus {\r\n  -webkit-text-fill-color: var(--text-primary) !important;\r\n  -webkit-box-shadow: 0 0 0 1000px var(--bg-input) inset !important;\r\n}\r\n\r\n.form-label { color: var(--text-secondary); font-weight: 500; }\r\n\r\n/* ── Global native element overrides ─────────────────────── */\r\n/* Catches any input/select/textarea not covered by component CSS.\r\n *\r\n * `.sf2-head-input` queda fuera a propósito: es el título editable de las\r\n * fichas en tarjetas (patrón inline edit) y necesita verse como un h1 sin caja\r\n * en reposo. Sin esta exclusión, el `!important` de aquí le pone fondo y borde\r\n * de campo siempre y no hay forma de pintarlo como título sin recurrir a otro\r\n * `!important` de mayor especificidad. */\r\ninput:not([type='checkbox']):not([type='radio']):not([type='range']):not([type='submit']):not([type='button']):not([type='reset']):not(.sf2-head-input),\r\nselect,\r\ntextarea {\r\n  background-color: var(--bg-input) !important;\r\n  border: 1px solid var(--border) !important;\r\n  color: var(--text-primary) !important;\r\n  border-radius: 6px;\r\n  font-family: inherit;\r\n}\r\n\r\ninput:not([type='checkbox']):not([type='radio']):not([type='range']):not([type='submit']):not([type='button']):not([type='reset']):not(.sf2-head-input)::placeholder,\r\ntextarea::placeholder {\r\n  color: var(--text-muted) !important;\r\n}\r\n\r\ninput:not([type='checkbox']):not([type='radio']):not([type='range']):not([type='submit']):not([type='button']):not([type='reset']):not(.sf2-head-input):focus,\r\nselect:focus,\r\ntextarea:focus {\r\n  outline: none !important;\r\n  border-color: var(--accent) !important;\r\n  box-shadow: 0 0 0 3px rgba(var(--accent-rgb),.2) !important;\r\n}\r\n\r\nselect option {\r\n  background: var(--bg-surface);\r\n  color: var(--text-primary);\r\n}\r\n\r\n\r\n/* Buttons */\r\n.btn {\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n.btn:hover {\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.btn-primary {\r\n  background: linear-gradient(135deg, var(--accent), var(--accent-2));\r\n  border: none;\r\n  color: #fff;\r\n}\r\n\r\n.btn-primary:hover {\r\n  background: linear-gradient(135deg, var(--accent-dark), #6d28d9);\r\n  box-shadow: 0 6px 20px rgba(var(--accent-rgb),.4);\r\n}\r\n\r\n/* Modals */\r\n.modal-content {\r\n  background: var(--bg-surface);\r\n  border: 1px solid var(--border);\r\n  box-shadow: var(--shadow-lg);\r\n  border-radius: 16px;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.modal-header {\r\n  background: var(--bg-toolbar);\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n\r\n.modal-footer {\r\n  background: var(--bg-toolbar);\r\n  border-top: 1px solid var(--border);\r\n}\r\n\r\n/* Badges */\r\n.badge {\r\n  border-radius: 0.25rem;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Alerts */\r\n.alert {\r\n  border-radius: 0.375rem;\r\n  border: none;\r\n}\r\n\r\n.alert-success {\r\n  background-color: rgba(25, 135, 84, 0.1);\r\n  color: #155724;\r\n}\r\n\r\n.alert-danger {\r\n  background-color: rgba(220, 53, 69, 0.1);\r\n  color: #721c24;\r\n}\r\n\r\n.alert-warning {\r\n  background-color: rgba(255, 193, 7, 0.1);\r\n  color: #856404;\r\n}\r\n\r\n.alert-info {\r\n  background-color: rgba(13, 202, 240, 0.1);\r\n  color: #0c5460;\r\n}\r\n\r\n/* Loading Spinner */\r\n.spinner-border {\r\n  color: var(--primary-color);\r\n}\r\n\r\n/* Pagination */\r\n.pagination .page-link {\r\n  color: var(--primary-color);\r\n  border: 1px solid var(--border-color);\r\n}\r\n\r\n.pagination .page-link:hover {\r\n  background-color: var(--light);\r\n  border-color: var(--border-color);\r\n}\r\n\r\n.pagination .page-item.active .page-link {\r\n  background-color: var(--primary-color);\r\n  border-color: var(--primary-color);\r\n}\r\n\r\n/* Utility Classes */\r\n.text-muted {\r\n  color: var(--secondary-color) !important;\r\n}\r\n\r\n.bg-light {\r\n  background-color: var(--light) !important;\r\n}\r\n\r\n.border-top {\r\n  border-top: 1px solid var(--border-color) !important;\r\n}\r\n\r\n.mt-4 {\r\n  margin-top: 1.5rem !important;\r\n}\r\n\r\n.mb-4 {\r\n  margin-bottom: 1.5rem !important;\r\n}\r\n\r\n.p-4 {\r\n  padding: 1.5rem !important;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .container-fluid {\r\n    padding: 0.5rem;\r\n  }\r\n\r\n  .card {\r\n    margin-bottom: 1rem;\r\n  }\r\n\r\n  .table {\r\n    font-size: 0.875rem;\r\n  }\r\n}\r\n\r\n/* Rack Visualization */\r\n.rack-container {\r\n  background-color: var(--bg-card);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 0.5rem;\r\n  padding: 1rem;\r\n  margin: 1rem 0;\r\n  box-shadow: var(--shadow);\r\n}\r\n\r\n.rack-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\r\n  gap: 1rem;\r\n  padding: 1rem;\r\n}\r\n\r\n.rack-item {\r\n  background-color: var(--bg-card);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 0.375rem;\r\n  padding: 0.75rem;\r\n  text-align: center;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.rack-item:hover {\r\n  border-color: var(--primary-color);\r\n  box-shadow: var(--shadow-lg);\r\n  transform: scale(1.02);\r\n}\r\n\r\n/* Footer\r\n   -------------------------------------------------------------------------\r\n   Aquí había un `footer { background-color: var(--dark); color: white;\r\n   padding: 2rem 1rem; ... }` heredado de una landing. En una aplicación no\r\n   tiene sentido: `--dark` es el color de TEXTO principal, así que cualquier\r\n   componente que usara <footer> como barra de acciones se pintaba con una caja\r\n   clara en modo oscuro y centrada. Ahora mismo el panel de plataforma usa\r\n   <footer className=\"pa-detail-actions\"> y se estilaba mal. Si algún día hace\r\n   falta un pie de página de verdad, que sea una clase propia (`.app-footer`),\r\n   nunca la etiqueta global. */\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
